var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    opacity: 0.496,
    cx: 24,
    cy: 24,
    r: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153.508.5.902 1.105 1.153 1.772.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772c-.5.508-1.105.902-1.772 1.153-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C14.013 27.056 14 26.717 14 24c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772 4.897 4.897 0 0 1 1.772-1.153c.638-.248 1.362-.415 2.428-.465C20.944 14.013 21.283 14 24 14zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM24 21a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInsta);
export default __webpack_public_path__ + "static/media/ic-Insta.4b9a603e5809a98bc0de8a71270136ef.svg";
export { ForwardRef as ReactComponent };